/**
 * Duplicates a base Postgres search payload across page indices for restoring cached table pages on mount.
 */

import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";

/**
 * Generates an array of search payloads for the initial data fetch, one per page
 * from page 0 through batchNumber (inclusive). Used to restore previously fetched pages
 * when the table re-mounts.
 *
 * @param payload - Base search payload to replicate per page
 * @param batchNumber - Last batch/page index to include (0-based)
 * @param searchTerm - Search query applied as `query` on each payload
 * @returns Array of payloads with `page` from `0` through `batchNumber` and the given `query`
 */
export const generatePayloadForInitialDataFetch = (
  payload: SearchForMedicalPaOrdersFromPostgresParams,
  batchNumber: number,
  searchTerm: string,
): SearchForMedicalPaOrdersFromPostgresParams[] => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...payload,
    page: index,
    query: searchTerm,
  }));
};
